<script>
import {ref, watch} from "vue";
import useTools from "@/use/Tools";
import {useWorkerStore} from "@/stores/Worker/Worker";
import useSharedSelectData from "@/use/SharedSelectData";
import PaySectionSelection from "@/components/PaySectionSelection.vue";
import useValidation from "@/use/Validation";
import {useSecurityStore} from "@/stores/Security";
import axios from "axios";
import useSharedData from "@/use/SharedData";

export default {
    components: {PaySectionSelection},
    props: {
        workerId: Number,
    },
    setup(props) {
        const worker = ref({});
        const {loading, backgroundColor} = useSharedData();
        const {mxRules} = useValidation();
        const {$refs, $swal} = useTools();
        const workerStore = useWorkerStore();
        const securityStore = useSecurityStore();
        const {profiles, modesIrg} = useSharedSelectData();
        
        
        function findById() {
            loading.value
            worker.value = {};
            axios.get(`/workers/${props.workerId}`).then(response => {
                worker.value = response.data;
            }).finally(() => {
                loading.value = false;
            });
        }
        
        function save() {
            if ($refs.form.validate()) {
                loading.value = true;
                axios.put('/workers', worker.value).then(response => {
                    workerStore.updateWorker(response.data);
                    $swal.fire('Employé mise à jour avec succès', '', 'success');
                }).finally(() => {
                    loading.value = false;
                });
            }
        }
        
        function updatePaySection(items) {
            worker.value.paySectionss = items;
        }
        
        watch(() => props.workerId, () => {
            if (props.workerId)
                findById();
        }, {immediate: true});
        
        watch(() => worker.value, () => {
            workerStore.setWorker(worker.value)
        }, {immediate: true, deep: true});
        
        return {
            mxRules,
            worker,
            loading,
            backgroundColor,
            profiles,
            modesIrg,
            save,
            updatePaySection,
            securityStore,
        }
    }
}
</script>

<template>
    <v-card>
        <v-form ref="form" lazy-validation>
            <v-container fluid>
                <v-tabs
                    class="tabs"
                    color="teal"
                    :background-color="backgroundColor"
                    vertical
                    slider-size="7"
                >
                    <v-tab>
                        <v-icon left>mdi-account-credit-card</v-icon>
                        {{ $t('common.paie') }}
                    </v-tab>
                    <v-tab>
                        <v-icon left>mdi-bookshelf</v-icon>
                        {{ $t('common.pay_sections') }}
                    </v-tab>
                    <!--<v-tab>
                        <v-icon left>mdi-account-credit-card</v-icon>
                        Bulletin
                    </v-tab>-->
                    <v-tab-item eager>
                        <v-container fluid>
                            <v-row>
                                <v-col cols="8">
                                    <w-label :label="$t('module.occupation')" required/>
                                    <str-occupation-autocomplete
                                        v-model="worker.occupationId"
                                        :rules="[mxRules.required]"
                                    />
                                </v-col>
                                <v-col cols="4">
                                    <w-label :label="$t('worker.mode_irg')"/>
                                    <w-enum-select
                                        v-model="worker.modeIrg"
                                        :items="modesIrg"
                                    />
                                </v-col>
                                <v-col cols="4">
                                    <w-label :label="$t('worker.profile')"/>
                                    <w-enum-select
                                        v-model="worker.profile"
                                        :items="profiles"
                                    />
                                </v-col>
                                <v-col cols="4">
                                    <w-label :label="$t('worker.abattement')"/>
                                    <str-worker-def-autocomplete
                                        v-model="worker.abattementId"
                                        :resource="'abattements'"
                                    />
                                </v-col>
                                <v-col cols="4">
                                    <w-label :label="$t('data_select.WORKER_CATEGORIZATION')"/>
                                    <w-data-select-autocomplete
                                        v-model="worker.categorizationId"
                                        type="WORKER_CATEGORIZATION"
                                    />
                                </v-col>
                                <v-col cols="4">
                                    <w-label :label="$t('pay_slip.rung')"/>
                                    <w-text-field
                                        v-model="worker.rung"
                                    />
                                </v-col>
                                <v-col cols="4">
                                    <w-label :label="$t('pay_slip.iep')"/>
                                    <w-text-field
                                        v-model="worker.iep"
                                    />
                                </v-col>
                                
                                <v-col cols="4">
                                    <v-switch
                                        v-model="worker.outOfGrille"
                                        :color="'red'"
                                        inset
                                        class="mt-7"
                                        :label="$t('worker.out_of_grille')"
                                        hide-details="auto"
                                    />
                                </v-col>
                                <v-col cols="4">
                                    <v-switch
                                        v-model="worker.simulated"
                                        color="teal"
                                        inset
                                        :label="$t('worker.pay_active')"
                                        hide-details="auto"
                                    />
                                </v-col>
                                <v-col cols="4">
                                    <v-switch
                                        v-model="worker.okCnas"
                                        inset
                                        color="blue"
                                        :label="$t('worker.ok_cnas')"
                                        hide-details
                                    />
                                </v-col>
                                <v-col cols="4">
                                    <v-switch
                                        v-model="worker.okMutuelle"
                                        inset
                                        color="purple"
                                        :label="$t('worker.ok_mutuelle')"
                                        hide-details
                                    />
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-tab-item>
                    <v-tab-item eager>
                        <pay-section-selection
                            v-if="worker.paySectionss"
                            :initial-pay-section-selection="worker.paySectionss"
                            :by-occupation="false"
                            :worker-id="workerId"
                            @updatePaySection="updatePaySection"
                        ></pay-section-selection>
                    </v-tab-item>
                    <!--<v-tab-item>
                        <paie-preview/>
                    </v-tab-item>-->
                </v-tabs>
            </v-container>
        </v-form>
        <v-divider/>
        <v-card-actions>
            <v-spacer/>
            <w-btn-update
                :show="worker.updateOption"
                :loading="loading"
                @press="save"
            />
        </v-card-actions>
    </v-card>
</template>

<style lang="scss" scoped>
div.tabs [role="tab"] {
    justify-content: flex-start;
}
</style>